<section class="rounded-lg border border-greyscale-200 bg-white p-4">
  <div class="flex items-center gap-3">
    <!-- icon -->
    @if (lucidIconRef) {
      <div
        class="flex h-10 w-10 items-center justify-center rounded-full bg-primary-200"
      >
        <lucide-icon
          [name]="lucidIconRef"
          class="text-primary-500"
          [size]="22"
        />
      </div>
    }
    <div class="flex-1">
      @if (title) {
        <h2 class="text-heading-3 font-semibold text-greyscale-950">
          {{ title }}
        </h2>
      }
      @if (subtitle) {
        <p class="text-paragraph-reg text-greyscale-700">
          {{ subtitle }}
        </p>
      }
    </div>
    <p-button
      (onClick)="colapsed = !colapsed"
      [text]="true"
      [icon]="colapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"
      size="small"
    />
  </div>
  @if (!colapsed) {
    <ng-content />
  }
</section>
